export class FcEvent {
    /**
     * ç³»ç»äºä»¶
     */
    static fc = {
        // è·åreduxçç¶æäºä»¶
        getStoreState: 'getStoreState',
    };

    /**
     * å¼¹çªäºä»¶
     */
    static fcmodal = {
        dialog: 'openDialog',
        confirm: 'openConfirm',
        error: 'openError',
        info: 'openInfo',
        success: 'openSuccess',
        warning: 'openWarning',
        input: 'input',
        component: 'component'
    };
    /**
     * å¾è¡¨äºä»¶
     */
    static fcchart = {
        activate: 'activate',
        deactivate: 'deactivate',
        select: 'select'
    };
    /**
     * fcnavbaräºä»¶
     */
    static fcnavbar = {
        // éæ°å è½½èåä¿¡æ¯
        fcnavbarLoadingMenu: 'fcnavbarLoadingMenu',
        // å è½½å®æèåä¿¡æ¯
        fcnavbarEndLoadMenu: 'fcnavbarEndLoadMenu',
        // ç¹å»åæ¢æ¾ç¤ºéèäºä»¶
        fcnavbarHideOrShowMenu: 'fcnavbarHideOrShowMenu',
        // ç¹å»æ¾ç¤ºèåäºä»¶
        fcnavbarShowMenu: 'fcnavbarShowMenu',
        // ç¹å»éèèåäºä»¶
        fcnavbarHideMenu: 'fcnavbarHideMenu',
        // ç¹å»åæ¢åä½äºä»¶
        fcnavbarSelectCompany: 'fcnavbarSelectCompany',
        // ç¹å»åæ¢ç»å½æ¥æ
        fcnavbarSelectDate: 'fcnavbarSelectDate',
        // éåºäºä»¶
        fcnavbarLogout: 'fcnavbarLogout',
        // æ¶æ¯æé
        fcnavbarMessageToggle: 'fcnavbarMessageToggle',
        // åæ¢å¸å±
        fcnavbarChangeLayout: 'fcnavbarChangeLayout',
        // æ¾ç¤ºæäºèå
        fcnavbarVisible: 'fcnavbarVisible',
        // éèæäºèå
        fcnavbarInvisible: 'fcnavbarInvisible',
    };
    /**
     * fcnavsideäºä»¶
     */
    static fcnavside = {
        // ä¾§è¾¹æ è§¦åäºä»¶
        fcnavsideToggle: 'fcnavsideToggle',
        fcnavsideClick: 'fcnavsideClick',
        fcnavsideClosed: 'fcnavsideClosed',
    };
    /**
     * fcnavtabäºä»¶
     */
    static fcnavtab = {
        // ä¾§è¾¹æ è§¦åäºä»¶
        fcnavtabSelected: 'fcnavtabSelected',
        // tabé¡µç¹å»
        fcnavtabClick: 'fcnavtabClick',
        // å³é­tabé¡µé¢
        fcnavtabClose: 'fcnavtabClose',
        // å³é­å¶å®é¡µé¢ï¼ä¸åå«homeé¡µé¢
        fcnavtabCloseOther: 'fcnavtabCloseOther',
        // æåå³é­åçäºä»¶
        fcnavtabClosed: 'fcnavtabClosed',
        // æ¸é¤tabs
        fcnavtabClearTabs: 'fcnavtabClearTabs',
        // æ¹åçªå£å¤§å
        fcnavtabResize: 'fcnavtabResize'
    };
    /**
     * fclistdataäºä»¶
     */
    static fclistdata = {
        // åæ¢éæ©é£äºå­æ®µæ¾ç¤ºäºä»¶
        fclistdataShowFields: 'fclistdataShowFields',
        fclistdataFilter: 'fclistdataFilter',
        fclistdataDataLoaded: 'fclistdataDataLoaded',
    };
}

